export default function AmountCheck(props, withDecimal = true) {
    if (isNaN(props)) {
        return props;
    } else {
        const [integerPart, decimalPart] = parseFloat(props).toFixed(2).toString().split(".");
        const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return withDecimal ? `${formattedIntegerPart}.${decimalPart}` : formattedIntegerPart;
    }
}
